import { PropertyHeaderContent } from 'framework-data-table';
import { useTableColumn, useTableColumns } from 'framework-listing-lib/internal/Table/providers/TableColumnsProvider';
import HeaderComponent, { HeaderContent } from 'framework-listing-lib/internal/Table/components/header/HeaderComponent';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function ListingLibPropertyHeader({
  columnName
}) {
  const {
    propertyMap
  } = useTableColumns();
  const column = useTableColumn(columnName);
  const propertyDefinition = propertyMap[columnName];
  if (!column) {
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "listing-lib-header-without-property-definition",
      children: columnName
    });
  }
  if (!propertyDefinition) {
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "listing-lib-header-without-property-definition",
      children: columnName
    });
  }
  let headerContent = /*#__PURE__*/_jsx(HeaderContent, {
    column: column
  });
  if (column.renderHeader) {
    headerContent = /*#__PURE__*/_jsx(_Fragment, {
      children: column.renderHeader({
        column
      })
    });
  }
  if (headerContent) {
    return /*#__PURE__*/_jsx(HeaderComponent, {
      column: column,
      children: headerContent
    });
  }
  return /*#__PURE__*/_jsx(PropertyHeaderContent, {
    propertyDefinition: propertyDefinition
  });
}